import { InvoiceRegister } from '../../../../models/invoice/invoice-register.model';

export interface NewRegisterModalPayload {
  registers: InvoiceRegister[],
  canEditDescription: boolean,
  canViewDescription: boolean,
  canEditDate: boolean,
  canViewDate: boolean,
  newRegisterMode: NewRegisterMode,
  getRegistersFromApi?: boolean,
  title?: string,
}

export enum NewRegisterMode {
  NEW = 'new',
  EXIST = 'exist',
  EMPTY = 'empty',
}
